import {createContext, useEffect, useState} from 'react';
import axios from 'axios'

export const VehicleContext = createContext();
export const VehicleContextProvider = ({children}) => {
    const baseURL = "https://ew.greenlightautomotivesolutions.com/bridge";

    const Axios = axios.create({ baseURL: baseURL });

    const [allPriceMismatchData,setAllPriceMismatchData] = useState([]);
    const [priceMismatchData,setPriceMismatchData] = useState([]);
    const [appraisalData,setAppraisalData] = useState({});
    const [filters, setFilters] = useState([]);

    const [zipCodeData, setZipCodeData] = useState({});

    const [searchText,setSearchText] = useState("");

    const [dealershipSold,setDealershipSold] = useState([]);

    const [makeModelData,setMakeModelData] = useState([]);

    const [marketcheckDealers,setMarketcheckDealers] = useState([]);

    const getPriceMismatchData = async (values) => {

        console.log(values);

        try {

            const response = await Axios.post('vehicles/price-mismatch.php',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            

            if(response.data.data) {

                setAllPriceMismatchData(response.data.data);

                var appraisal_data = {};

                const appraisals = response.data.data.map(async (v,i) => {
                    /*if(i < 20 && v.appraisal == 0) {
                        const this_appraisal = await getAppraisal(v);

                        appraisal_data[v.vin] = {'appraisal':this_appraisal.appraisal || "",'avg_retail':this_appraisal.avg_retail || ""}; 
                    } else*/
                        appraisal_data[v.vin] = {'appraisal':v.appraisal,'avg_retail':v.avg_retail}; 
                });
                setAppraisalData(appraisal_data);
            } 
            
            if (response.data.filters) setFilters(response.data.filters);

            if(response.data.zipcode_data) {
                var newZipData = {};

                response.data.zipcode_data.map((v,i) => {
                    newZipData[v.zip_code] = v;
                });

                setZipCodeData(newZipData);
            }

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const getDealershipSoldData = async (values) => {

        console.log(values);

        try {

            const response = await Axios.post('vehicles/dealer-sold.php',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            if(response.data) setDealershipSold(response.data);

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };


    const getDealershipLiveData = async (values,live=false) => {

        console.log(values);

        try {

            const response = await Axios.post('vehicles/dealer-sold-live.php',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            return response.data;

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const getAllLiveData = async (values,live=false) => {

        console.log(values);

        try {

            const response = await Axios.post('live/live-deals.php',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            return response.data;

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const getDealershipAnalysis = async (values) => {

        console.log(values);

        try {

            const response = await Axios.post('vehicles/dealer-analysis.php',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            return response.data;

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const updateDealerInfo = async (values) => {

        console.log(values);

        try {

            const response = await Axios.post('vehicles/dealer-info.php',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const getDealershipMatch = async (values) => {

        console.log(values);

        try {

            const response = await Axios.post('vehicles/dealer-match.php',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            return response.data;

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const dealershipMatchSave = async (values) => {

        console.log(values);

        try {

            const response = await Axios.post('vehicles/dealer-match-save.php',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            return response.data;

        } catch (error) {
            console.error('Error saving rankings:', error);
            return {}; // Or handle error as needed
        }
    };

    const getFitAnalysis = async (values) => {

        console.log(values);

        try {

            const response = await Axios.post('vehicles/dealer-fit-analysis.php',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            return response.data;

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const getMonroneyLabel = async (values) => {

        console.log(values);

        try {

            const response = await Axios.post('vehicles/labels.php',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            return response.data;

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const getVautoAppraisal = async (values) => {

        console.log(values);

        try {

            const response = await Axios.post('vehicles/vauto_appraisal.php',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            return response.data;

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const uploadLiveExport = async (values) => {

        console.log(values);

        const {data} = await Axios.post('live/import_live.php',values).catch(function (error) {
            if (error.response) console.log(error.response.data, error.response.status, error.response.headers);
            else if (error.request) console.log(error.request);
            else console.log('Error', error.message);
            console.log(error.config);
            var error_data = {"error" : error, "url" : error.request && error.request.url ? error.request.url : "none provided"};
            //email_axios_error(error_data);
            console.log(error_data);
        });

        console.log(data);

        return data;
    }

    const validateVIN = (inputVIN) => {
        if(!inputVIN) return false;

        var vin = inputVIN.toLowerCase().trim();
    
        var patt = new RegExp("^[^Wioq]{17}$");
    
        if (!patt.test(vin)) {
            return false;
        }
    
        var weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
    
        var transliterations = [];
    
        transliterations["a"] = 1;
        transliterations["b"] = 2;
        transliterations["c"] = 3;
        transliterations["d"] = 4;
        transliterations["e"] = 5;
        transliterations["f"] = 6;
        transliterations["g"] = 7;
        transliterations["h"] = 8;
        transliterations["j"] = 1;
        transliterations["k"] = 2;
        transliterations["l"] = 3;
        transliterations["m"] = 4;
        transliterations["n"] = 5;
        transliterations["p"] = 7;
        transliterations["r"] = 9;
        transliterations["s"] = 2;
        transliterations["t"] = 3;
        transliterations["u"] = 4;
        transliterations["v"] = 5;
        transliterations["w"] = 6;
        transliterations["x"] = 7;
        transliterations["y"] = 8;
        transliterations["z"] = 9;
    
        var sum = 0;
        var i = 0;
    
        for (i = 0; i < vin.length; i++) {
            // loop through characters of VIN
            // add transliterations * weight of their positions to get the sum
            if (isNaN(vin[i])) {
            sum += transliterations[vin[i]] * weights[i];
            } else {
            sum += parseInt(vin[i]) * weights[i];
            }
        }
    
        var checkdigit = sum % 11;
    
        if (checkdigit == 10) {
            checkdigit = "x";
        }
    
        return checkdigit == vin[8];
    }

    const decodeVIN = async (vin) => {
        try {

            var values = {vin:vin};

            const response = await Axios.post('vehicles/decode.php',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            return response.data.attributes || {};

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    }

    const getAppraisal = async (vehicle_data) => {
        try {

            if(validateVIN(vehicle_data['vin'])) {

                console.log("getting appraisal",vehicle_data);

                const response = await Axios.post('vehicles/get_appraisal.php',vehicle_data,{
                    retry: 0, retryDelay: 3000
                });

                console.log(response.data);

                if(response.data.appraisal) {

                    insertAppraisal(response.data);

                    if (vehicle_data['vin'] in appraisalData) {

                        let appraisal_data = {...appraisalData};
                        
                        appraisal_data[vehicle_data['vin']] = {'appraisal':response.data.appraisal || "",'avg_retail':response.data.avg_retail || ""};

                        setAppraisalData(appraisal_data);
                    }

                }

                return response.data || {};

            } else {
                console.log("invalid vin for appraisal",vehicle_data);

                return {};
            }

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    }

    const insertAppraisal = async (vehicle_data) => {
        try {

            console.log("inserting appraisal",vehicle_data);

            const response = await Axios.post('vehicles/insert_appraisal.php',vehicle_data,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            return response.data || {};

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    }

    const getMakeModels = async () => {

        try {

            const response = await Axios.get('vehicles/make-models.php',{
                retry: 0, retryDelay: 3000
            });

            const data = response.data;

            var formatted_data = [];

            /*
                            {
                    title: "Lexus",
                    models: [
                        { name: "Bentayga", checked: false },
                        { name: "Continental GT", checked: false },
                    ],
                }
            */

            Object.entries(data).map(([i,v]) => {
                var model_data = [];

                v.map((w,j) => {
                    model_data.push({name:w,checked:false})
                });

                formatted_data.push({
                    title:i,
                    models:model_data
                });
            });

            console.log(response.data,formatted_data);

            setMakeModelData(formatted_data);

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const getMarketcheckDealers = async () => {

        try {

            const response = await Axios.get('vehicles/marketcheck-dealers.php',{
                retry: 0, retryDelay: 3000
            });

            if(response.data) setMarketcheckDealers(response.data);

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const numberFormatter = (value, currency = false, ignore_thousands = false) => {
        var sign = value >= 0 ? "" : "-";
        var num = value ? value.toString().replace(/[^0-9\.]+/g,"") : 0;
        var millions = !ignore_thousands && num >= 1000000;
        var thousands = !ignore_thousands && num >= 1000;
    
        if(millions) num = Math.round(num / 100000) / 10;
        else if(thousands) num = Math.round(num / 100) / 10;
        
        var str = num.toString().replace("$", ""), parts = false, output = [], i = 1, formatted = null;
        if(str.indexOf(".") > 0) {
            parts = str.split(".");
            str = parts[0];
        }
        str = str.split("").reverse();
        for(var j = 0, len = str.length; j < len; j++) {
            if(str[j] != ",") {
                output.push(str[j]);
                if(i%3 == 0 && j < (len - 1)) {
                    output.push(",");
                }
                i++;
            }
        }
        formatted = output.reverse().join("");
        return((currency ? "$" : "") + sign + formatted + ((parts) ? "." + parts[1].substr(0, 2) : "") + (millions ? "MM" : (thousands ? "k" : "")));
    }

    /*search stuff*/

    const filterVehicles = (vehicleData) => {
        var filteredResults;

        if (!searchText) {
            filteredResults = vehicleData;
        } else {
            filteredResults = vehicleData.filter(vehicle =>
                (vehicle.title && (vehicle.title.toLowerCase() + '').includes(searchText.toLowerCase()))
            );
        }

        return filteredResults;
    }
    useEffect(() => {

        var filteredResults = filterVehicles(allPriceMismatchData);

        setPriceMismatchData(filteredResults);
    }, [searchText, allPriceMismatchData]);

    return (
        <>
            <VehicleContext.Provider value={{priceMismatchData, appraisalData, filters, setFilters, getPriceMismatchData,numberFormatter,searchText,setSearchText,getDealershipSoldData,getDealershipLiveData,getDealershipAnalysis,getDealershipMatch,dealershipMatchSave,getFitAnalysis,dealershipSold,setDealershipSold,getMakeModels,makeModelData,getMonroneyLabel,validateVIN,decodeVIN,getAppraisal,zipCodeData,getVautoAppraisal,getMarketcheckDealers,marketcheckDealers,updateDealerInfo,uploadLiveExport,getAllLiveData}}>
                {children}
            </VehicleContext.Provider>
        </>
    );
}

export default VehicleContextProvider